module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_blue_en-81a74c3d46f88890b47c043a97eaa574.png";